"use client";

import { Icon } from "@/components/ui/Icon";
import { pushToDataLayer } from "@/lib/analytics/pushToDataLayer";
import { IconName } from "@/types";

interface ContactLinkProps {
  variant: "dark" | "light";
  id: string;
  href: string;
  label: string;
  icon: IconName;
}

export const ContactLink: React.FC<ContactLinkProps> = ({
  variant,
  id,
  href,
  label,
  icon,
}) => {
  const iconColor = variant === "dark" ? "text-purple-medium" : "text-yellow";
  return (
    <p
      className={`flex flex-row not-italic gap-x-4 mt-sm ${variant === "dark" ? "childLinkDark" : "childLinkLight"}`}
    >
      <Icon name={icon} size={24} className={`${iconColor}`} />
      <a
        href={href}
        onClick={() => pushToDataLayer({ event: "click_Footer_Icons", id })}
      >
        {label}
      </a>
    </p>
  );
};
